import type { ComponentProps } from 'react';

export const NFCIcon = (props:ComponentProps<'svg'>) => (
  <svg width="175" height="136" viewBox="0 0 175 136" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M87.5 8.1748C108.365 8.1748 127.358 14.6728 141.194 25.3086C155.033 35.9467 163.825 50.8389 163.825 67.5C163.825 84.1611 155.033 99.0533 141.194 109.691C127.358 120.327 108.365 126.825 87.5 126.825C66.6347 126.825 47.6416 120.327 33.8057 109.691C19.9668 99.0533 11.1748 84.1611 11.1748 67.5C11.1748 50.8389 19.9668 35.9467 33.8057 25.3086C47.6416 14.6728 66.6347 8.1748 87.5 8.1748Z"
      stroke="currentColor" strokeWidth="5.65135" />
    <path d="M68 48C72.9437 53.1236 76 60.1929 76 68C76 75.8071 72.9437 82.8764 68 88" stroke="currentColor"
          strokeWidth="5.65135" strokeLinecap="round" />
    <path d="M76 40C83.4163 47.1775 88 57.0731 88 68C88 78.9269 83.4163 88.8225 76 96" stroke="currentColor"
          strokeWidth="5.65135" strokeLinecap="round" />
    <path d="M85 32C94.2697 41.2242 100 53.9485 100 68C100 82.0515 94.2697 94.7758 85 104" stroke="currentColor"
          strokeWidth="5.65135" strokeLinecap="round" />
    <path d="M93 24C104.117 35.2324 111 50.7981 111 68C111 85.2019 104.117 100.768 93 112" stroke="currentColor"
          strokeWidth="5.65135" strokeLinecap="round" />
  </svg>
)